import { render, staticRenderFns } from "./array-input.vue?vue&type=template&id=640e2886"
import script from "./array-input.vue?vue&type=script&lang=js"
export * from "./array-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports